import React from 'react';
import { NavLink } from 'react-router-dom';
import '../css/Nav.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <a href="/" className="navbar-logo">Panel</a>
      <div className="navbar-links">
        <NavLink to="/prestamos" className="navbar-link">Préstamos</NavLink>
        <NavLink to="/abonos" className="navbar-link">Abonos</NavLink>
        <NavLink to="/deudas" className="navbar-link">Deudas</NavLink>
      </div>
    </nav>
  );
};

export default Navbar;
